// TableView.js
// import React from 'react';
// import { useTable } from 'react-table';

// const TableView = ({ data }) => {
//     debugger
//     console.log('first', data);
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: 'CustMobile',
//         accessor: 'CustMobile', // Assuming your data has an 'id' property
//       },
//       {
//         Header: 'Name',
//         accessor: 'emailId', // Replace with the actual property in your data
//       },
//       // Add more columns based on your data structure
//     ],
//     []
//   );

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

//   return (
//     <table {...getTableProps()} style={{ borderCollapse: 'collapse', width: '100%' }}>
//       <thead>
//         {headerGroups.map(headerGroup => (
//           <tr {...headerGroup.getHeaderGroupProps()}>
//             {headerGroup.headers.map(column => (
//               <th {...column.getHeaderProps()} style={{ border: '1px solid black', padding: '8px' }}>
//                 {column.render('Header')}
//               </th>
//             ))}
//           </tr>
//         ))}
//       </thead>
//       <tbody {...getTableBodyProps()}>
//         {rows.map(row => {
//           prepareRow(row);
//           return (
//             <tr {...row.getRowProps()}>
//               {row.cells.map(cell => (
//                 <td {...cell.getCellProps()} style={{ border: '1px solid black', padding: '8px' }}>
//                   {cell.render('Cell')}
//                 </td>
//               ))}
//             </tr>
//           );
//         })}
//       </tbody>
//     </table>
//   );
// };

// export default TableView;

// TableView.js
import React, { useState } from 'react';

const TableView = ( { data1 }) => {
  // Assuming the first item in the array has all the keys for columns

  const [data,setData] =useState(data1);
  console.log('data data', data)

  const columns = Object.keys(data[0] || {}).map(key => ({
    Header: key,
    accessor: key,
  }));

  console.log('fircolumnsst', columns);

  return (
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <thead>
        <tr>
          {columns.map(column => (
            <th key={column.accessor} style={{ border: '1px solid black', padding: '8px' }}>
              {column.Header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map(column => (
              <td key={column.accessor} style={{ border: '1px solid black', padding: '8px' }}>
                {row[column.accessor]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableView;

